// extracted by mini-css-extract-plugin
export var addButton = "_bv-0";
export var border = "_bv-8";
export var check = "_bv-h";
export var danger = "_bv-6";
export var dropdownContainer = "_bv-1";
export var editModalBody = "_bv-j";
export var footerContainer = "_bv-i";
export var fullWidth = "_bv-a";
export var hide = "_bv-9";
export var icon = "_bv-3";
export var input = "_bv-7";
export var inputFlex = "_bv-b";
export var inputWrapper = "_bv-c";
export var manualFocus = "_bv-5";
export var optionButton = "_bv-4";
export var pillWrapper = "_bv-e";
export var pointer = "_bv-2";
export var showOverflow = "_bv-f";
export var tagsFlex = "_bv-d";
export var xButton = "_bv-g";